// components/shared/AuthorRedirectModal.jsx
import { useEffect, useState } from 'react';

const STORAGE_KEY = 'reanlo_seen_author_prompt';

export default function AuthorRedirectModal() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const seen = localStorage.getItem(STORAGE_KEY);
    if (!seen) setVisible(true);
  }, []);

  function dismiss() {
    localStorage.setItem(STORAGE_KEY, 'true');
    setVisible(false);
  }

  function goToAuthorSite() {
    localStorage.setItem(STORAGE_KEY, 'true');
    window.open('https://reanloforauthors.com', '_blank', 'noopener,noreferrer');
    setVisible(false);
  }

  // Escape closes it, the same way the Support sheet's does
  // (SupportJar.jsx). Closing counts as an answer, exactly like "No, I'm a
  // reader": the prompt is remembered as seen and does not come back. An
  // author who closes it still has the navbar's "Are you an author?" link.
  useEffect(() => {
    if (!visible) return;
    const onKey = e => { if (e.key === 'Escape') dismiss(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [visible]);

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: 'rgba(41, 37, 36, 0.55)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 'var(--space-xl)',
    }}>
      <div style={{
        position: 'relative',
        background: 'var(--brand-paper)',
        borderRadius: 'var(--radius-xxl)',
        padding: '36px 32px',
        maxWidth: 420,
        width: '100%',
        textAlign: 'center',
        boxShadow: '0 20px 60px rgba(41,37,36,0.18)',
        border: '1px solid var(--brand-sand)',
      }}>
        <button
          onClick={dismiss}
          aria-label="Close"
          style={{
            position: 'absolute', top: 14, right: 14, width: 36, height: 36,
            borderRadius: 'var(--radius-circle)', border: 'none', cursor: 'pointer',
            background: 'transparent', color: 'var(--neutral-500)',
            fontSize: 22, lineHeight: 1,
          }}
        >
          ×
        </button>

        {/* Icon */}
        <div style={{
          width: 56, height: 56,
          background: 'var(--feedback-warning-bg)',
          borderRadius: 'var(--radius-circle)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 26, margin: '0 auto 20px',
        }}>
          ✍️
        </div>

        <h2 style={{
          fontFamily: 'var(--font-display)',
          fontSize: 22, fontWeight: 700,
          color: 'var(--neutral-800)', margin: '0 0 10px',
        }}>
          Are you an author?
        </h2>

        <p style={{
          fontFamily: 'var(--font-body)',
          fontSize: 'var(--font-size-md)', color: 'var(--neutral-500)',
          lineHeight: 1.6, margin: '0 0 28px',
        }}>
          Reanlo has a dedicated space for authors to manage their books,
          connect with both readers and authors, and grow their presence.
        </p>

        <button
          onClick={goToAuthorSite}
          style={{
            width: '100%',
            padding: '13px 0',
            background: 'var(--brand-rust)',
            color: 'var(--brand-white)',
            border: 'none',
            borderRadius: 'var(--radius-lg)',
            fontFamily: 'var(--font-body)',
            fontSize: 15, fontWeight: 700,
            cursor: 'pointer',
            marginBottom: 'var(--space-10)',
            transition: 'background 0.15s',
          }}
          onMouseEnter={e => e.currentTarget.style.background = '#a04e30'}
          onMouseLeave={e => e.currentTarget.style.background = '#B85C38'}
        >
          Yes, take me to the Author Portal →
        </button>

        <button
          onClick={dismiss}
          style={{
            width: '100%',
            padding: '12px 0',
            background: 'transparent',
            color: 'var(--neutral-500)',
            border: '1px solid var(--brand-sand)',
            borderRadius: 'var(--radius-lg)',
            fontFamily: 'var(--font-body)',
            fontSize: 'var(--font-size-md)', fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          No, I'm a reader, continue
        </button>
      </div>
    </div>
  );
}